exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".guide .box-content{padding:0 0 12px}.guide .video-wrapper{margin-top:0}.guide .checklist-item.checked,.guide .checklist-item.checked a{color:#bbb}.guide .checklist-item.checked .checkbox label:before{border-color:#bbb}.guide .checklist-item.checked .checkbox label:after{color:#bbb}.reset-guide{display:inline-block;width:100%;text-align:right}", ""]);

// exports
